import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import HtmlParser from 'react-html-parser'
import get from 'lodash.get'
import Typography from 'components/atoms/Typography'
import MediaGrid from 'components/organisms/MediaGrid'
import './Album.scss'

function Album({ data }) {
  const medias = get(data, 'route.entity.medias')
  const title = get(data, 'route.entity.title')
  const description = get(data, 'route.entity.body.value')
  

  return (
    <div className="album">
      <div className="bg-gray-400 pt-5">
        <Container>
          <Row className="pb-4">
            <Col>
              <Typography className="album__title text-primary">{title}</Typography>
            </Col>
          </Row>
        </Container>
      </div>
      <Container className="py-4">
        {description && (
          <Row className="pb-4">
            <Col>
              <Typography component="span" color="gray-100">
                {HtmlParser(description)}
              </Typography>
            </Col>
          </Row>
        )}

        <MediaGrid medias={medias} />
      </Container>
    </div>
  )
}

export default Album